<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <label
                      >Show
                      <select
                        name="users-list-select"
                        class="form-control form-control-sm d-inline-block width-100 p-right-25 pl-4 mx-1"
                        (click)="updateLimit($event)"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      entries</label
                    >
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1">
                        <label for="ngx-filter-ref"
                          >Search:
                          <input
                            id="ngx-filter-ref"
                            class="form-control form-control-sm d-inline-block width-200 ml-1"
                            type="text"
                            
                          />
                        </label>
                      </div>
                      <!-- <div class="faq-wrapper">
                        <div class="faq-search">
                          <form
                            class="d-flex justify-content-center ng-untouched ng-pristine ng-valid"
                          >
                            <div
                              class="faq-search-input form-group position-relative w-100 mb-0"
                            >
                              <input
                                type="text"
                                (keyup)="getCategoryFilter($event)"
                                class="form-control form-control-lg shadow p-3"
                                id="searchbar"
                                placeholder="Search"
                              />
                              <button
                                class="btn btn-primary position-absolute"
                                type="button"
                              >
                                <span class="d-none d-sm-block">Search</span>
                                <i class="ft-search d-block d-sm-none"></i>
                              </button>
                            </div>
                          </form>
                        </div>
                      </div> -->
                      <div class="col-flex-2 mb-1" *ngIf=" user_role.roles =='admin' || user_role.roles =='extractor'">
                        <button
                          type="reset"
                          class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/notifications/add-notification"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Notifications Guideline</button>
                    </div>
                </div>
              </fieldset>
              <ngx-datatable
                class="bootstrap core-bootstrap"
                [columnMode]="ColumnMode.force"
                [headerHeight]="50"
                [footerHeight]="50"
                rowHeight="auto"
                [limit]="limitRef"
                [rows]="rows"
                [scrollbarH]="true"
                [columns]="columns"
                [externalPaging]="true"
                [count]="page.totalPages"
                [offset]="page.offset"
                (page)="pageChangeData($event)"
              >
                <ngx-datatable-column
                  name="User"
                  prop="user"
                  [width]="60"
                >
                  <ng-template
                    let-row="row"
                    let-name="value"
                    ngx-datatable-cell-template
                  >
                    <div class="d-flex align-items-center">
                      <img
                        class="rounded-circle mr-1"
                        *ngIf="row.image"
                        [src]="imageUrl + row.image"
                        height="32"
                        width="32"
                      />
                      <img
                        class="rounded-circle mr-1"
                        *ngIf="!row.image"
                        src="assets/MeanderLIVE-icon.png"
                        height="32"
                        width="32"
                      />
  
                      <div class="cell-line-height"  [routerLink]="['/attendance/attendance-view', row._id]"
                      (click)="editAttendance(row._id)">
                        <p class="font-medium-1 line-height-1 mb-0 cursor-pointer">
                          {{ row.user.name }}
                        </p>
                        <!-- <span class="text-muted font-small-2">
                          Nuclear Power Engineer</span
                        > -->
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column
                  name="Title"
                  prop="title"
                  [width]="70"
                >
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row.title}}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
                name="Description"
                prop="description"
                [width]="70"
                >
            </ngx-datatable-column>
            <ngx-datatable-column
                name="IsRead"
                prop="isRead"
                [width]="40"
                >
                <ng-template  let-row="row" ngx-datatable-cell-template>
                 <div *ngIf="row.isRead == false" class="bg-light-danger">
                  {{row.isRead}}
                 </div>
                 <div *ngIf="row.isRead == true" class="bg-light-success">
                  {{row.isRead}}
                 </div>
              </ng-template>
            </ngx-datatable-column>
                <ngx-datatable-column name="Actions" [width]="50" *ngIf=" user_role.roles =='admin' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i
                      class="ft-edit text-primary cursor-pointer mr-2"
                      [routerLink]="['/notifications/edit-notification', row._id]"
                      (click)="editNotification(row._id)"
                    ></i>
                    <i *ngIf=" user_role.roles =='admin'"
                      class="ft-trash-2 cursor-pointer danger"
                      (click)="ConfirmColor(row._id)"
                    ></i>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  
